/**
 * フェイクテーブルのリスト
 */

// 基本情報
const headTitleList1: any[] = [
  {
    headTitle: "新設・申出年月日",
  },
  {
    headTitle: "施設情報",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設区分",
  },
  {
    headTitle: "当該施設・事業を経営している証拠書類",
  },
];

// 「特定介護保険施設等」又は「申出施設等」に該当する申込施設の付加情報
const headTitleList2: any[] = [
  {
    headTitle: "施設名",
  },
  {
    headTitle: "給与支払遅延の有無",
  },
  {
    headTitle: "当該施設等が共済契約を締結していたことの有無",
  },
  {
    headTitle: "解除年月日",
  },
  {
    headTitle: "帳票",
  },
];

// 職員数情報
const headTitleList3: any[] = [
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設名",
  },
  {
    headTitle: "入所定員（利用定員）",
  },
  {
    headTitle: "職員配置基準数",
  },
  {
    headTitle: "職員情報登録",
  },
];

const headTitleList4: any[] = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

export { headTitleList1, headTitleList2, headTitleList3, headTitleList4 };
